import { Helmet } from "react-helmet";
import Header from "../../../Components/Header";
import BomForm from "./BomForm";
import { useLocation } from "react-router-dom";

const ViewBom = () => {
  const location = useLocation();
  const bomId = location.state?.bomId;
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>BOM - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <BomForm bomId={bomId} />
      </div>
    </div>
  );
};

export default ViewBom;
